export const STATUS_OPTIONS = [
  { value: "AVAILABLE", label: "Available" },
  { value: "OVERAGE", label: "Overage" },
  { value: "MISSING", label: "Missing" },
  { value: "EXCESS_INSCAN", label: "Excess Inscan" },
];

export const STATUS_TAG = {
  AVAILABLE: { color: "success", label: "Available" },
  OVERAGE: { color: "warning", label: "Overage" },
  MISSING: { color: "error", label: "Missing" },
  EXCESS_INSCAN: { color: "purple", label: "Excess Inscan" },
};

export const EMPTY_COUNTS = {
  availableCount: 0,
  overageCount: 0,
  missingCount: 0,
  excessInscanCount: 0,
  totalCount: 0,
};

export const extractShipmentsPayload = (reportData) => {
  const payload = reportData?.data || reportData || {};

  if (Array.isArray(payload)) {
    return { shipments: payload, counts: { ...EMPTY_COUNTS } };
  }

  if (Array.isArray(payload.shipments)) {
    return {
      shipments: payload.shipments,
      counts: {
        availableCount: payload.availableCount ?? 0,
        overageCount: payload.overageCount ?? 0,
        missingCount: payload.missingCount ?? 0,
        excessInscanCount: payload.excessInscanCount ?? 0,
        totalCount: payload.totalCount ?? payload.shipments.length,
      },
    };
  }

  if (Array.isArray(payload.data)) {
    return { shipments: payload.data, counts: { ...EMPTY_COUNTS } };
  }

  return { shipments: [], counts: { ...EMPTY_COUNTS } };
};
